import styles from './index.module.scss'

export function DashboardPage() {
  return <div className={styles.dashboard}>dashboard page</div>
}
